import React from 'react'

// @ts-ignore
import WistiaVideo from 'app/domains/common/WistiaVideo'

import './styles.scss'
const bc = 'my-activities-dangerously-text'

const MyActivitiesDangerouslyText: React.FC<any> = ({ image, description, name, order, videoId, videoThumbnail }) => {
  return (
    <div className={bc}>
      <div className={`${bc}__title`}>{`${order}. ${name}`}</div>
      {videoId ? (
        <WistiaVideo height={180} videoId={videoId} videoThumbnail={videoThumbnail} />
      ) : (
        <img src={image} className={`${bc}__image`} alt={name} />
      )}
      <div className={`${bc}__description`}>{description}</div>
    </div>
  )
}

export default MyActivitiesDangerouslyText
